import {
  GET_DOCUMENT_TEMPLATES,
  GET_DOCUMENT_TEMPLATE,
  CREATE_DOCUMENT_TEMPLATE,
  UPDATE_DOCUMENT_TEMPLATE,
  DELETE_DOCUMENT_TEMPLATE
} from '../actions/documentTemplateActions';

const initialState = {
  templates: [],
  template: null,
  isLoading: false
};

const documentTemplateReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DOCUMENT_TEMPLATES:
      return {
        ...state,
        templates: action.payload,
        isLoading: false
      };

    case GET_DOCUMENT_TEMPLATE:
      return {
        ...state,
        template: action.payload,
        isLoading: false
      };

    case CREATE_DOCUMENT_TEMPLATE:
      return {
        ...state,
        templates: [action.payload, ...state.templates]
      };

    case UPDATE_DOCUMENT_TEMPLATE:
      return {
        ...state,
        templates: state.templates.map(t =>
          t._id === action.payload._id ? action.payload : t
        ),
        template: action.payload
      };

    case DELETE_DOCUMENT_TEMPLATE:
      return {
        ...state,
        templates: state.templates.filter(t => t._id !== action.payload)
      };

    default:
      return state;
  }
};

export default documentTemplateReducer;
